import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Observable, catchError, map } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface CriteriaDescription {
  name: string;
  label: string;
  description: string;
}

export function getCriteriaDescriptions(): CriteriaDescription[] {
  return [
    {
      name: 'areaPreservacaoPermanente',
      label: 'Área de Preservação Permanente',
      description: 'Área protegida, coberta ou não por vegetação nativa, com a função ambiental de preservar os recursos hídricos, a paisagem, a estabilidade geológica e a biodiversidade, facilitar o fluxo gênico de fauna e flora, proteger o solo e assegurar o bem-estar das populações humanas.'
    },
    {
      name: 'iterpaGlebas',
      label: 'Iterpa Glebas',
      description: 'Grandes extensões de terras públicas estaduais delimitadas para fins de ordenamento territorial e regularização fundiária.'
    },
    {
      name: 'iterpaPeas',
      label: 'Iterpa Peas',
      description: 'Projetos Estaduais de Assentamento Sustentável) são áreas voltadas para a agricultura familiar que utilizam os recursos naturais de forma racional.'
    },
    {
      name: 'iterpaPeax',
      label: 'Iterpa Peax',
      description: 'Projetos Estaduais de Assentamento Agroextrativista criados pelo Instituto de Terras do Pará.'
    },
    {
      name: 'iterpaQuilombos',
      label: 'Iterpa Quilombos',
      description: 'Processos de regularização fundiária, demarcação e titulação definitiva das terras ocupadas por comunidades quilombolas em áreas públicas'
    },
    {
      name: 'historicoFocosQueimadas',
      label: 'Histórico de Focos de Queimadas',
      description: 'Registros históricos de focos de queimadas detectados em áreas públicas'
    },
    {
      name: 'ibamaEmbargo',
      label: 'Área Embargada',
      description:
        'Os embargos exibidos tratam dos termos de embargos vigentes lavrados pelo IBAMA. Lei nº 12.527, de 18 de novembro de 2011 Art. 8º, § 2º Lei Nº 10.650, de 16 de abril de 2003 Art. 4º, incisos III e V. Decreto Nº 6.514, de 22 de julho de 2008. Art. 18, §1º, art. 149, incisos I e II, parágrafo único. Áreas Embargadas divulgadas no site do IBAMA.',
    },
    {
      name: 'slavery',
      label: 'Trabalho Escravo',
      description:
        'Cadastro de Empregadores que tenham submetido trabalhadores a condições análogas à de escravo (Lista Suja do Trabalho Escravo) - Portaria Interministerial MTPS/MMIRDH nº 4 de 11/05/2016.',
    },
    {
      name: 'quilombolaAreas',
      label: 'Áreas Quilombolas',
      description:
        'Territórios ocupados por comunidades remanescentes de quilombos, grupos formados por descendentes de escravizados (INCRA).',
    },
    {
      name: 'archeologicalSites',
      label: 'Sítios Arqueológicos',
      description:
        'Locais que contêm vestígios de atividades humanas antigas, como ruínas, artefatos e estruturas (IPHAN).',
    },
    {
      name: 'archaeologicalSites',
      label: 'Sítios Arqueológicos',
      description:
        'Locais que contêm vestígios de atividades humanas antigas, como ruínas, artefatos e estruturas (IPHAN).',
    },
    {
      name: 'miningAreas',
      label: 'Áreas de Mineração',
      description:
        'Regiões geográficas com atividades de extração de minerais, como metais, pedras preciosas, carvão, petróleo e gás natural (ANM / SIGMINE).',
    },
    {
      name: 'deter',
      label: 'Deter',
      description:
        'Áreas de desmatamento detectadas após 05/10/2009 pelo Projeto de Detecção do Desmatamento em Tempo Real (DETER), ou seus substitutos.',
    },
    {
      name: 'prodes',
      label: 'Desmatamento Recente (PRODES)',
      description:
        'Áreas de desmatamento detectadas pelo Projeto de Monitoramento do Desflorestamento na Amazônia Legal (PRODES), ou seus substitutos.',
    },
    {
      name: 'conservationUnit',
      label: 'Unidade de Conservação',
      description:
        'Áreas de Unidades de Conservação da base oficial do IBAMA.',
    },
    {
      name: 'indigenousLand',
      label: 'Terra Indígena',
      description:
        'Áreas Indígenas da base oficial da Fundação Nacional do Índio (FUNAI).',
    },
    {
      name: 'indigenousLands',
      label: 'Terra Indígena',
      description:
        'Áreas Indígenas da base oficial da Fundação Nacional do Índio (FUNAI).',
    },
    {
      name: 'publicForests',
      label: 'Florestas Públicas (CNFP)',
      description:
        'Cadastro de Florestas Públicas da União, estados e municípios, vinculado ao Sistema Nacional de Cadastro Rural (SNCR) do INCRA.',
    },
    {
      name: 'embargoSiga',
      label: 'Embargo Siga',
      description:
        'Polígonais dos Embargos Ambientais do Estado de Goiás, cadastrados nos sistemas INÃ e SGA da SEMAD-GOIÁS.',
    },
    {
      name: 'embargoSema',
      label: 'Embargo SEMA',
      description:
        'Polígonos de áreas embargadas pela Secretaria de Estado de Meio Ambiente do estado de Mato Grosso.',
    },
    {
      name: 'lar',
      label: 'LAR PA',
      description:
        'Licença de Atividade Rural das propriedades maiores de 3000ha emitida pela Secretaria de Meio Ambiente do estado do Pará (SEMAS).',
    },
    {
      name: 'ldi',
      label: 'LDI PARÁ',
      description:
        'Lista do Desmatamento Ilegal do Estado do Pará, criada pelo Decreto Estadual nº 838/2013, gerida pela SEMAS/PA para consulta pública.',
    },
    {
      name: 'icmBio',
      label: 'ICMBio',
      description:
        'Limites de Unidades de Conservação Federais, exceto Reservas Particulares, fornecidos pelo Instituto Chico Mendes de Conservação da Biodiversidade (ICMBio).',
    },
    {
      name: 'icmBioEmbargo',
      label: 'Embargo ICMBio',
      description:
        'Áreas embargadas fornecidas pelo Instituto Chico Mendes de Conservação da Biodiversidade (ICMBio).',
    },
    {
      name: 'icmBioInfractions',
      label: 'Autos de infração ICMBio',
      description:
        'Localização de infrações fornecida pelo Instituto Chico Mendes de Conservação da Biodiversidade (ICMBio).',
    },
    {
      name: 'mapBiomasWarning',
      label: 'Alerta Mapbiomas',
      description:
        'Alerta de desmatamento recente fornecido pelo MAPBIOMAS. Publica toda perda de vegetação nativa, sem julgamento sobre legalidade ou responsabilidade. Os alertas vêm de diversos sistemas de detecção para todos os biomas do Brasil.',
    },
    {
      name: 'altaBiodiversidadeArgentina',
      label: 'Áreas de alta biodiversidade',
      description: 'Áreas de alta biodiversidade.',
    },
    {
      name: 'ibasArgentina',
      label: 'Áreas importantes para a conservação de Aves',
      description:
        'Visa identificar, monitorar e proteger uma rede de áreas críticas para as aves e biodiversidade em geral.',
    },
    {
      name: 'vegetacaoNativaArgentina',
      label: 'Áreas de mata nativa',
      description: 'Áreas de mata nativa.',
    },
    {
      name: 'otbnArgentina',
      label: 'Ordenamento Territorial de Bosques Nativos (OTBN)',
      description:
        'Instrumento de planejamento territorial usado na Argentina para classificar áreas de florestas nativas com base em seu valor de conservação. Cada província realiza seu próprio OTBN, determinando as atividades permitidas por categoria.',
    },
    {
      name: 'ramsarArgentina',
      label: 'Zonas Úmidas RAMSAR',
      description:
        'The Convention on Wetlands é um tratado intergovernamental que fornece a estrutura para a conservação e uso racional de zonas úmidas e seus recursos.',
    },
    {
      name: 'terrasIndigenasArgentina',
      label: 'Terras Indígenas da Argentina',
      description: 'Localização de comunidades indígenas na Argentina.',
    },
    {
      name: 'alertasDeDesmatamentoIntegrados',
      label: 'Alertas Integrados de Desmatamento',
      description:
        'Agrega alertas de desmatamento de três sistemas (GLAD-L, GLAD-S2, RADD), permitindo detecção mais rápida. Montado pelo Global Forest Watch.',
    },
    {
      name: 'alertasDeDesmatamentoRadd',
      label: 'Alertas de Desmatamento RADD',
      description:
        'Usa dados dos satélites Sentinel-1 da ESA para detectar distúrbios florestais em quase tempo real. Desenvolvido pela Wageningen University e Global Forest Watch.',
    },
    {
      name: 'perdaDeCoberturaArborea',
      label: 'Perda de Cobertura Arbórea',
      description:
        'Mede áreas de perda de cobertura arbórea global com resolução de 30x30 metros. Colaboração entre Universidade de Maryland (GLAD), Google, USGS e NASA. Dados do Global Forest Watch.',
    },
  ];
}

@Injectable({
  providedIn: 'root'
})
export class SolicitacoesService {
  protected storage: Storage;
  protected httpOptions: any;
  protected token: any;
  protected customerId: string = '';

  newRequestsFilterForm: FormGroup = new FormGroup({
    producer: new FormControl(''),
    document: new FormControl(''),
    car: new FormControl(''),
    requestNumber: new FormControl(''),
    status: new FormControl(''),
    initialDate: new FormControl(''),
    propertyName: new FormControl(''),
    activitiesDescription: new FormControl(''),
    finalDate: new FormControl(''),
    page: new FormControl(0),
    size: new FormControl(15),
  });

  answeredRequestsFilterForm: FormGroup = new FormGroup({
    producer: new FormControl(''),
    protocol: new FormControl(''),
    car: new FormControl(''),
    requestNumber: new FormControl(''),
    status: new FormControl(''),
    initialDate: new FormControl(''),
    propertyName: new FormControl(''),
    activitiesDescription: new FormControl(''),
    finalDate: new FormControl(''),
    page: new FormControl(0),
    size: new FormControl(15),
  });

  pendingInformationFilterForm: FormGroup = new FormGroup({
    producer: new FormControl(''),
    document: new FormControl(''),
    car: new FormControl(''),
    requestNumber: new FormControl(''),
    status: new FormControl(''),
    initialDate: new FormControl(''),
    propertyName: new FormControl(''),
    finalDate: new FormControl(''),
    activitiesDescription: new FormControl(''),
    page: new FormControl(0),
    size: new FormControl(15),
  });

  analiseDetalhadaFilterForm: FormGroup = new FormGroup({
    producer: new FormControl(''),
    document: new FormControl(''),
    car: new FormControl(''),
    requestNumber: new FormControl(''),
    status: new FormControl(''),
    initialDate: new FormControl(''),
    propertyName: new FormControl(''),
    finalDate: new FormControl(''),
    activitiesDescription: new FormControl(''),
    page: new FormControl(0),
    size: new FormControl(15),
  });

  resetAnaliseDetalhadaFilterForm() {
    this.analiseDetalhadaFilterForm.reset();
    this.analiseDetalhadaFilterForm.get('page')?.setValue(0);
    this.analiseDetalhadaFilterForm.get('size')?.setValue(15);
  }

  resetPendingInformationFilterForm() {
    this.pendingInformationFilterForm.reset();
    this.pendingInformationFilterForm.get('page')?.setValue(0);
    this.pendingInformationFilterForm.get('size')?.setValue(15);
  }

  resetAnsweredRequestsFilterForm() {
    this.answeredRequestsFilterForm.reset();
    this.answeredRequestsFilterForm.get('page')?.setValue(0);
    this.answeredRequestsFilterForm.get('size')?.setValue(15);
  }

  resetNewRequestsFilterForm() {
    this.newRequestsFilterForm.reset();
    this.newRequestsFilterForm.get('page')?.setValue(0);
    this.newRequestsFilterForm.get('size')?.setValue(15);
  }

  constructor(private http: HttpClient) {
    this.storage = window.sessionStorage;

    const item = this.storage.getItem('token');
    this.token = item ? JSON.parse(item) : {};

    const itemUser = this.storage.getItem('user');
    const user = itemUser ? JSON.parse(itemUser) : {};
    this.customerId = user.customerId;

    this.httpOptions = {
      headers: new HttpHeaders({
        Authorization: this.token,
      })
    };
  }

  public registerRequest(body: any, sendMail?: any, hasKML?: any, hasCoordinates?: any): Observable<Object> {
    return this.http.post<Object>(`${environment.api}/geo-monitoring/register/with-protocol?sendMail=${sendMail}&hasKML=${hasKML}&hasCAR=${hasCoordinates}`, body, this.httpOptions);
  }

  public listNewRequest(options: {
    size: number;
    page: number;
    status?: string;
    startRequestDate?: string;
    endRequestDate?: string;
    producerName?: string;
    producerDocument: string;
    requestNumber?: string;
    sendDate?: string;
    producerPlace?: string;
    propertyName?: string;
    activitiesDescription?: string;
  }): Observable<Object> {

    let params;
    if (options.startRequestDate && options.endRequestDate) {
      params = new HttpParams()
        .set('startRequestDate', options.startRequestDate)
        .set('endRequestDate', options.endRequestDate)
        .set('page', options.page)
        .set('size', options.size);
    }
    else {
      params = new HttpParams()
        .set('page', options.page)
        .set('size', options.size);
    }

    if (options.status) {
      params = params.set('status', options.status || 'ENABLED');
    }
    if (options.requestNumber) {
      params = params.set('requestNumber', options.requestNumber);
    }
    if (options.producerDocument) {
      params = params.set('producerDocument', options.producerDocument);
    }
    if (options.sendDate) {
      params = params.set('sendDate', options.sendDate);
    }
    if (options.producerPlace) {
      params = params.set('producerPlace', options.producerPlace);
    }
    if (options.producerName) {
      params = params.set('producerName', options.producerName);
    }
    if (options.propertyName) {
      params = params.set('nickname', options.propertyName);
    }
    if (options.activitiesDescription) {
      params = params.set('activitiesDescription', options.activitiesDescription);
    }

    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: this.token,
      }),
      params,
    };

    return this.http.get<Object>(`${environment.api}/geo-monitoring/list/new-requests/filtered/${this.customerId}`, httpOptions).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((error: any) => {
        throw error;
      })
    );
  }


  changeToNotEnabled(id: any, sendMail: boolean = true): Observable<Object> {
    let params = new HttpParams();

    if (this.token) {
      params = params.set('token', this.token);
      params = params.set('sendMail', sendMail);
    }

    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `${this.token}`,
      }),
      params,
    };

    return this.http.put<Object>(
      `${environment.api}/geo-monitoring/change-status-to-not-enabled/${id}`,
      null,
      httpOptions
    );
  }

  changeStatus(id: any, status: string, sendMail: boolean = true): Observable<Object> {
    let params = new HttpParams().set('sendMail', sendMail);

    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `${this.token}`,
      }),
      params
    };

    return this.http.patch<Object>(`${environment.api}/geo-monitoring/change-status/${id}?status=${status}`, null, httpOptions);
  }

  public listAllRequests(): Observable<Object> {
    return this.http.get<Object>(`${environment.api}/geo-monitoring/list`, this.httpOptions).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((error: any) => {
        throw error;
      })
    );
  }
  convertKmlToGeoJSON(kmlUrl: string): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: `${this.token}`,
    });

    return this.http.get<any>(kmlUrl, { headers, responseType: 'text' as 'json' });
  }
  public validateRequest(id: string, sendMail: boolean = true) {
    let params = new HttpParams().set('sendMail', sendMail);

    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: this.token,
      }),
      params,
    };

    return this.http.post<Object>(`${environment.api}/geo-monitoring/send-to-safegistrace/${id}`, {}, httpOptions);
  }

  sendMessage(body: any, sendMail: boolean = true, frontUrl: string) {
    let params = new HttpParams().set('customerId', this.customerId).set('sendMail', sendMail).set('frontUrl', frontUrl);

    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: this.token,
      }),
      params,
    };

    return this.http.post<Object>(`${environment.api}/geo-monitoring/send-message`, body, httpOptions);
  }

  sendGenericMessage(body: any) {
    return this.http.post<Object>(`${environment.api}/default-messages`, body, this.httpOptions);
  }

  public listGenericMessages(reference: any): Observable<Object> {
    return this.http.get<Object>(`${environment.api}/default-messages/${reference}`, this.httpOptions).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((error: any) => {
        throw error;
      })
    );
  }

  public listRequestAnswered(options: {
    size: number;
    page: number;
    status: string;
    startRequestDate?: string;
    endRequestDate?: string;
    producerDocument: string;
    producerName?: string;
    requestNumber?: string;
    sendDate?: string;
    producerPlace?: string;
    propertyName?: string;
    activitiesDescription?: string;
  }) {
    let params;
    if (options.startRequestDate && options.endRequestDate) {
      params = new HttpParams()
        .set('startRequestDate', options.startRequestDate)
        .set('endRequestDate', options.endRequestDate)
        .set('page', options.page)
        .set('size', options.size);
    }
    else {
      params = new HttpParams()
        .set('page', options.page)
        .set('size', options.size);
    }

    if (options.status) {
      params = params.set('status', options.status || 'ENABLED');
    }
    if (options.requestNumber) {
      params = params.set('requestNumber', options.requestNumber);
    }
    if (options.producerDocument) {
      params = params.set('producerDocument', options.producerDocument);
    }
    if (options.sendDate) {
      params = params.set('sendDate', options.sendDate);
    }
    if (options.producerPlace) {
      params = params.set('producerPlace', options.producerPlace);
    }
    if (options.producerName) {
      params = params.set('producerName', options.producerName);
    }
    if (options.propertyName) {
      params = params.set('nickname', options.propertyName);
    }
    if (options.activitiesDescription) {
      params = params.set('activitiesDescription', options.activitiesDescription);
    }

    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: this.token,
      }),
      params,
    };

    return this.http.get<Object>(`${environment.api}/geo-monitoring/list/with-response/filtered/${this.customerId}`, httpOptions).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((error: any) => {
        throw error;
      })
    );
  }

  public listRequestsAnsweredWithoutResponse(options: {
    size: number;
    page: number;
    status: string;
    startRequestDate?: string;
    endRequestDate?: string;
    producerDocument?: string;
    producerName?: string;
    requestNumber?: string;
    sendDate?: string;
    producerPlace?: string;
    propertyName?: string;
    activitiesDescription?: string;
  }) {
    let params;

    if (options.startRequestDate && options.endRequestDate) {
      params = new HttpParams()
        .set('startRequestDate', options.startRequestDate)
        .set('endRequestDate', options.endRequestDate)
        .set('page', options.page)
        .set('size', options.size);
    }
    else {
      params = new HttpParams()
        .set('page', options.page)
        .set('size', options.size);
    }

    if (options.status) {
      params = params.set('status', options.status || 'ENABLED');
    }
    if (options.requestNumber) {
      params = params.set('requestNumber', options.requestNumber);
    }
    if (options.producerDocument) {
      params = params.set('producerDocument', options.producerDocument);
    }
    if (options.sendDate) {
      params = params.set('sendDate', options.sendDate);
    }
    if (options.producerPlace) {
      params = params.set('producerPlace', options.producerPlace);
    }
    if (options.producerName) {
      params = params.set('producerName', options.producerName);
    }
    if (options.propertyName) {
      params = params.set('nickname', options.propertyName);
    }
    if (options.activitiesDescription) {
      params = params.set('activitiesDescription', options.activitiesDescription);
    }

    params = params.set('name', this.customerId);

    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: this.token,
      }),
      params,
    };

    return this.http.get<Object>(`${environment.api}/geo-monitoring/list-all`, httpOptions).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((error: any) => {
        throw error;
      })
    );
  }

  public listRequestAnsweredPaginated(options: {
    size: number;
    page: number;
    status?: string;
    startRequestDate?: string;
    endRequestDate?: string;
    producerDocument: string;
    requestNumber?: string;
    sendDate?: string;
    producerPlace?: string;
    activitiesDescription?: string;
  }): Observable<Object> {
    let params;

    if (options.startRequestDate && options.endRequestDate) {
      params = new HttpParams()
        .set('startRequestDate', options.startRequestDate)
        .set('endRequestDate', options.endRequestDate)
        .set('page', options.page)
        .set('size', options.size);
    }
    else {
      params = new HttpParams()
        .set('page', options.page)
        .set('size', options.size);
    }
    if (options.status) {
      params = params.set('status', options.status || 'ENABLED');
    }
    if (options.requestNumber) {
      params = params.set('requestNumber', options.requestNumber);
    }
    if (options.producerDocument) {
      params = params.set('producerDocument', options.producerDocument);
    }
    if (options.sendDate) {
      params = params.set('sendDate', options.sendDate);
    }
    if (options.producerPlace) {
      params = params.set('producerPlace', options.producerPlace);
    }
    if (options.activitiesDescription) {
      params = params.set('activitiesDescription', options.activitiesDescription);
    }

    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: this.token,
      }),
      params,
    };


    return this.http.get<Object>(`${environment.api}/geo-monitoring/list/with-response/filtered/${this.customerId}`, httpOptions).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((error: any) => {
        throw error;
      })
    );
  }

  public getRequestById(id: string) {
    return this.http.get<Object>(`${environment.api}/geo-monitoring/find/${id}`, this.httpOptions);
  }

  public updateRequest(body: any, sendMail: boolean = true) {
    let params = new HttpParams().set('sendMail', sendMail);

    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: this.token,
      }),
      params
    }

    return this.http.post<Object>(`${environment.api}/geo-monitoring/update`, body, httpOptions);
  }

  public getId(hash: string) {
    return this.http.get<Object>(`${environment.api}/geo-monitoring/find/${hash}`, this.httpOptions).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((error: any) => {
        throw error;
      })
    );
  }

  public getDatasRequestById(id: any) {
    return this.http.get(`${environment.api}/geo-monitoring/dto/list/with-response/filtered/${this.customerId}?`,
      {
        headers: new HttpHeaders({
          Authorization: this.token,
          'Content-Type': 'application/json',
        }),
        params: {
          id: id,
        },
      });
  }

  public getListRequests(options: any) {
    let params = new HttpParams();

    if (options.page) params = params.append('page', options.page);
    if (options.size) params = params.append('size', options.size);
    if (options.startRequestDate) params = params.append('startRequestDate', options.startRequestDate);
    if (options.endRequestDate) params = params.append('endRequestDate', options.endRequestDate);
    if (options.producerName) params = params.append('producerName', options.producerName);
    if (options.requestNumber) params = params.append('requestNumber', options.requestNumber);
    if (options.producerDocument) params = params.append('producerDocument', options.producerDocument);
    if (options.producerPlace) params = params.append('producerPlace', options.producerPlace); // CAR
    if (options.status) params = params.append('status', options.status);
    if (options.propertyName) params = params.append('nickname', options.propertyName);
    if (options.activitiesDescription) params = params.append('activitiesDescription', options.activitiesDescription);

    return this.http.get(`${environment.api}/geo-monitoring/dto/list/with-response/filtered/${this.customerId}`, {
      headers: new HttpHeaders({
        Authorization: this.token,
        'Content-Type': 'application/json',
      }),
      params: params,
    });
  }

  public findRequestById(id: any) {
    return this.http.get(`${environment.api}/geo-monitoring/dto/find-by-id/${this.customerId}?`,
      {
        headers: new HttpHeaders({
          Authorization: this.token,
          'Content-Type': 'application/json',
        }),
        params: {
          id: id,
        },
      });
  }

  public getListTowns(state: any): Observable<Object> {
    return this.http.get<Object>(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${state}/distritos?orderBy=nome`).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((error: any) => {
        throw error;
      })
    );
  }

  public getCityById(cityId: any): Observable<Object> {
    return this.http.get<Object>(`https://servicodados.ibge.gov.br/api/v1/localidades/municipios/${cityId}`).pipe(
      map((response: any) => {
        if (response.length === 0) {
          throw Error;
        } else {
          return response;
        }
      }),
      catchError((error: any) => {
        throw error;
      })
    );
  }

  public getFile(file: string) {
    return this.http.get(`${environment.api}/reader-service/download?`,
      {
        headers: new HttpHeaders({
          Authorization: this.token,
          'Content-Type': 'application/json',
        }),
        responseType: 'blob',
        params: {
          filePath: file,
        },
      });
  }

  public getGeoJsonFile(file: string) {
    var apiUrl = `${environment.api}/reader-service/download?filePath=` + file;
    return fetch(apiUrl, {
      headers: {
        'Authorization': this.token
      }
    })
      .then(response => response.json())
  }
  public async getTextFile(file: string) {
    var apiUrl = `${environment.api}/reader-service/download?filePath=` + file;
    return fetch(apiUrl, {
      headers: {
        'Authorization': this.token
      }
    })
      .then(response => response.text())

  }
  public uploadFile(uploadFiles: any) {
    const formData = new FormData();
    for (var i = 0; i < uploadFiles.length; i++) {
      formData.append('file', uploadFiles[i]);
    }


    return this.http.post(`${environment.api}/reader-service/upload `, formData, {
      headers: new HttpHeaders({
        Authorization: this.token,
      }),
      responseType: 'text'
    });
  }

  getStatusColor(status: string): string {
    const statusColors: { [key: string]: string } = {
      'ENABLED': 'green',
      'POST_ANALYSIS_ENABLED': 'green',
      'NOT_ENABLED': 'yellow',
      'POST_ANALYSIS_NOT_ENABLED': 'red',
      'ANALYSIS_IN_PROGRESS': 'yellow',
      'VALIDATING': 'yellow',
      'PENDING': 'red',
    };
    return statusColors[status] || '';
  }

  getStatusName(status: string): string {
    const statusColors: { [key: string]: string } = {
      'ENABLED': 'Habilitado',
      'POST_ANALYSIS_ENABLED': 'Habilitado AD',
      'NOT_ENABLED': 'Em Análise AD',
      'POST_ANALYSIS_NOT_ENABLED': 'Não Habilitado AD',
      'ANALYSIS_IN_PROGRESS': 'Analisando',
      'VALIDATING': 'Validando',
      'PENDING': 'Pendente',
    };
    return statusColors[status] || '';
  }

  getStatusRenovaBio(status: string): string {
    const statusColors: { [key: string]: string } = {
      'ENABLED': 'Elegível',
      'NOT_ENABLED': 'Inelegível',
    };
    return statusColors[status] || '';
  }
}
